import CaisseConfirmModal from '../caisse/CaisseConfirmModal';

function formatMoney(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  return `${n.toFixed(2)} €`;
}

function additionPaymentHint(a) {
  if (a.statut === 'ANNULEE') return 'Annulée';
  const solde = a.solde != null ? Number(a.solde) : null;
  if (solde != null && solde <= 0.009) return 'Soldée';
  if (Number(a.montantEncaisse || 0) > 0.009) return `Solde ${formatMoney(solde ?? a.total)}`;
  return `À régler ${formatMoney(solde ?? a.total)}`;
}

export default function RestaurantReleaseTableModal({
  open,
  onClose,
  onConfirm,
  processing,
  tableLabel,
  floorName,
  additions = [],
  canClose,
}) {
  const label = tableLabel || '—';
  const title = `Libérer la table ${label} ?`;

  return (
    <CaisseConfirmModal
      open={open}
      title={title}
      confirmLabel="Confirmer la libération"
      cancelLabel="Annuler"
      onCancel={onClose}
      onConfirm={onConfirm}
      processing={processing}
      testIdConfirm="restaurant-liberate-confirm"
      testIdCancel="restaurant-liberate-cancel"
    >
      <div className="space-y-3 text-sm text-slate-700">
        <p>
          <span className="font-medium">Table {label}</span>
          {floorName ? (
            <>
              {' '}
              · salle <span className="font-medium">{floorName}</span>
            </>
          ) : null}
        </p>
        <p>
          {additions.length} addition{additions.length !== 1 ? 's' : ''} sur ce service.
        </p>
        {additions.length > 0 && (
          <ul className="border rounded-xl divide-y max-h-40 overflow-y-auto" data-testid="restaurant-liberate-additions">
            {additions.map((a) => (
              <li key={a.id} className="px-3 py-2 flex justify-between gap-2 text-xs">
                <span className="font-mono">{a.numeroTicket || a.numero || a.id.slice(-6)}</span>
                <span>{additionPaymentHint(a)}</span>
              </li>
            ))}
          </ul>
        )}
        {canClose === true && (
          <p className="text-emerald-800 bg-emerald-50 border border-emerald-200 rounded-xl px-3 py-2">
            Aucun solde dû — la table peut être libérée.
          </p>
        )}
        <p className="text-slate-600">
          Le service sera clôturé. L&apos;historique des additions et des paiements est conservé.
        </p>
      </div>
    </CaisseConfirmModal>
  );
}
